// extracted by mini-css-extract-plugin
export var assigneeBadge = "_k3-0";
export var assigneeDetails = "_k3-1";
export var assigneeInfo = "_k3-2";
export var dropdownContainer = "_k3-4";
export var dropdownImage = "_k3-5";
export var editAssigneeInfo = "_k3-3";
export var editAssigneeModalContainer = "_k3-6";
export var hidden = "_k3-8";
export var input = "_k3-7";